import SelectionMenuBase from '../../../components/SelectionMenuBase/SelectionMenuBase';
import { SelectionCombination } from '../../../components/SelectedCombination';
import BaseInputs from './BaseInputs/BaseInputs';
import { Icons } from '../../../components/Icon/Icon';
import { useEffect, useState } from 'react';
import AsideMenuSelectionMenuGroup, {
    asideMenuSelectionMenuGroups,
} from '../../../components/AsideMenuSelection/AsideMenuSelectionMenuGroup';

const TaxOptimisationSelection = ({
    setSelectedData,
    selectedData,
    selectedDetails,
    onEdit,
    active,
    setActive,
    hidden,
    handleSelectedInvestor,
}: any) => {
    // useEffect(() => {
    //     console.log('selectedDetails', selectedDetails, { ...(selectedDetails || {}), ...selectedData });
    // }, [selectedDetails]);
    const [openCategory, setOpenCategory] = useState<undefined | string>(asideMenuSelectionMenuGroups.selection);
    const [contentHeight, setcontentHeight] = useState(900);

    useEffect(() => {
        setcontentHeight(970 + 80 * selectedData.investors.length + 20 * selectedData.assets.length);
    }, [selectedData]);

    const toggleCategory = (category: any) => {
        setOpenCategory(openCategory === category ? undefined : category);
    };

    return (
        <>
            <SelectionMenuBase
                info={<BaseInputs selectedData={selectedData} setSelectedData={setSelectedData} />}
                active={active}
                setActive={setActive}
                hidden={hidden}
            >
                <div>
                    <AsideMenuSelectionMenuGroup
                        icon={Icons.chevronDownFilled}
                        label={'Initial inputs'}
                        setOpenCategory={toggleCategory}
                        openCategory={openCategory}
                        category={asideMenuSelectionMenuGroups.selection}
                        contentHeight={contentHeight}
                        onEdit={onEdit}
                    >
                        <SelectionCombination
                            selectedData={{ ...(selectedDetails || {}), ...selectedData }}
                            isOptimisation={false}
                            hideFundRow={true}
                            fundData={
                                !selectedDetails?.investmentFund
                                    ? undefined
                                    : {
                                          fund: selectedDetails?.investmentFund.name,
                                          country: selectedDetails?.investmentFund.countryCode,
                                      }
                            }
                            isSelectable={true}
                            handleSelectedInvestor={handleSelectedInvestor}
                        />
                    </AsideMenuSelectionMenuGroup>
                </div>
            </SelectionMenuBase>

            {/*<div>*/}
            {/*    <TransitionComponent inProp={!active} duration={100}>*/}
            {/*        <p className={styles.graphTip}>*/}
            {/*            /!*{comments ? `${comments.legendId} : ${comments.fullComments}` : ''}*!/*/}
            {/*            {legends*/}
            {/*                ? legends.map((l, i) => (*/}
            {/*                      <React.Fragment key={i}>*/}
            {/*                          {l} <br />*/}
            {/*                      </React.Fragment>*/}
            {/*                  ))*/}
            {/*                : ''}*/}
            {/*        </p>*/}
            {/*    </TransitionComponent>*/}
            {/*</div>*/}
        </>
    );
};

export default TaxOptimisationSelection;
